"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const store_1 = __importDefault(require("@/store"));
const routes_1 = require("@/enums/routes");
class RegistrationForm {
    constructor() {
        this.portalType = (0, vue_1.computed)(() => {
            return store_1.default.getters.portalType();
        });
        this.isLoggedIn = (0, vue_1.computed)(() => {
            return store_1.default.getters.isLoggedIn();
        });
    }
    mounted() {
        this.redirectWhenLoggedIn();
    }
    redirectWhenLoggedIn() {
        if (this.isLoggedIn.value) {
            this.redirectToResult();
            return;
        }
        this.triggerAuthenticationService();
        this.waitForAuthCompleted();
    }
    triggerAuthenticationService() {
        document.dispatchEvent(new CustomEvent('RenderAuthenticationService', {
            detail: {
                referrer: 'CountryTest',
                tabToShow: 'third_party_login'
            }
        }));
    }
    waitForAuthCompleted() {
        const boundRedirectFunction = this.redirectToResult.bind(this);
        // Wait for either opt_in_success.
        document.addEventListener('opt_in_success', boundRedirectFunction);
        // Or opt_out before redirecting.
        document.addEventListener('opt_out', boundRedirectFunction);
        // Opt-in failed.
        document.addEventListener('opt_in_fail', boundRedirectFunction);
        // When an existing user logs in.
        document.addEventListener('logging_in_existing_user', () => {
            // After the user is logged in, go to results.
            document.addEventListener('student_logged_in', boundRedirectFunction);
        });
    }
    redirectToResult() {
        store_1.default.mutations.setCurrentRoute(routes_1.Routes.RESULTS);
    }
}
exports.default = RegistrationForm;
